export default __webpack_public_path__ + "static/media/blank-profile-picture.fe86956e.png";